import React from "react";
import {
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import Iconify from "../iconify/Iconify";

const PacksTable = ({ packs, navigate }) => {
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 300 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>#</TableCell>
            <TableCell>Name</TableCell>
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {packs?.map((row, index) => (
            <TableRow
              key={index}
              sx={{
                "&:last-child td, &:last-child th": {
                  border: 0,
                },
              }}
            >
              <TableCell component="th" scope="row">
                {row.packId}
              </TableCell>

              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>

              <TableCell component="th" scope="row">
                <Iconify
                  icon="eva:eye-outline"
                  onClick={() => {
                    navigate(`/dashboard/pack-details?pack_id=${row.packId}`);
                  }}
                  sx={{ cursor: "pointer" }}
                />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default PacksTable;
